import { FormPartialDataUsPersonInfo } from "../components/FormPartialUsPersonInfo";
import { getUserProfile } from "../../../services/api/user/getUserProfile";
import { isSameDateSafe } from "../../../utils/dates";

export const selectorUsPersonPartialFormData = (props: {
  dob?: Date;
  userProfile?: Awaited<ReturnType<typeof getUserProfile>>;
}): Partial<FormPartialDataUsPersonInfo> => {
  const startDate = props.userProfile?.taxProfiles?.["US"]?.startDate;

  return {
    firstName: props.userProfile?.taxProfiles?.["US"]?.firstName,
    lastName: props.userProfile?.taxProfiles?.["US"]?.lastName,
    usPersonDate:
      startDate instanceof Date
        ? startDate
        : startDate
          ? new Date(startDate)
          : undefined,
    usPersonSince: isSameDateSafe(props.dob, startDate) ? "always" : "date"
  };
};
